module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    attrs: {
      "color": _vm.snackbarColor
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarMsg) + "\n    "), _c('v-btn', {
    attrs: {
      "color": "orange",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("fermer")])], 1), _vm._v(" "), _c('v-container', [_c('h1', {
    staticClass: "pt-5 red--text",
    attrs: {
      "color": "error"
    }
  }, [_vm._v("Gestion de la base")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.DeleteAreasEnriched
    }
  }, [_vm._v("Supprimer les aires enrichies")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.copyingAreas
    },
    on: {
      "click": _vm.copyAires
    }
  }, [_vm._v("Copier les aires")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.copyComments
    }
  }, [_vm._v("Copier les commentaires")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.downloadDB
    }
  }, [_vm._v("Créer dump base")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ed331e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DBManagement.vue
// module id = 457
// module chunks = 1